import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

export default class extends Controller {
  static targets = ["addressSelect", "preview", "newAddressForm", "editAddressForm", "primaryOption"]
  static values = { workspaceId: String }

  connect() {
    if (this.hasAddressSelectTarget) {
      const selectedOption = this.addressSelectTarget.selectedOptions[0]
      if (selectedOption && selectedOption.value !== "new") {
        this.showPreviewForOption(selectedOption)
      }

      // Add form validation to prevent submission when "new" is selected
      const form = this.element.closest('form')
      if (form) {
        this._boundValidateAddress = this.validateAddress.bind(this)
        this._form = form
        this._form.addEventListener('submit', this._boundValidateAddress)
      }
    }
  }

  disconnect() {
    if (this._form && this._boundValidateAddress) {
      this._form.removeEventListener('submit', this._boundValidateAddress)
    }
    this._form = null
    this._boundValidateAddress = null
  }

  showSelectedAddressPreview() {
  if (this.hasAddressSelectTarget) {
    const selectedOption = this.addressSelectTarget.selectedOptions[0]
    if (selectedOption && selectedOption.value !== "new") {
      this.showPreviewForOption(selectedOption)
    }
  }
}

  validateAddress(event) {
    if (this.hasAddressSelectTarget && this.addressSelectTarget.value === "new") {
      event.preventDefault()
      alert("Please save the new address or select an existing address before creating the order.")
      this.addressSelectTarget.focus()
      return false
    }
  }

  selectAddress(event) {
    const selectedValue = event.target.value
    const selectedOption = event.target.selectedOptions[0]

    if (selectedValue === "new") {
      this.showNewAddressForm()
      this.hideEditAddressForm()
      this.hideAllPreviews()
    } else {
      this.hideNewAddressForm()
      this.hideEditAddressForm()
      this.showPreviewForOption(selectedOption)
    }
  }

  showPreviewForOption(option) {
    const previewTargetId = option.dataset.previewTarget

    this.hideAllPreviews()

    if (previewTargetId) {
      const previewElement = document.getElementById(previewTargetId)
      if (previewElement) {
        previewElement.classList.remove("d-none")
      }
    }
  }

  hideAllPreviews() {
    this.previewTargets.forEach(preview => {
      preview.classList.add("d-none")
    })
  }

  showNewAddressForm() {
    if (this.hasNewAddressFormTarget) {
      this.newAddressFormTarget.classList.remove("d-none")
    }
  }

  hideNewAddressForm() {
    if (this.hasNewAddressFormTarget) {
      this.newAddressFormTarget.classList.add("d-none")
    }
  }

  hideEditAddressForm() {
    if (this.hasEditAddressFormTarget) {
      this.editAddressFormTarget.classList.add("d-none")
    }
  }

  async showEditForm(event) {
    event.preventDefault()
    const addressId = event.currentTarget.dataset.addressId

    if (!addressId || addressId === "null" || addressId === "undefined") {
      console.error("Invalid addressId:", addressId)
      return
    }

    this.hideAllPreviews()
    this.hideNewAddressForm()

    if (this.hasEditAddressFormTarget) {
      this.editAddressFormTarget.classList.remove("d-none")
    }

    const url = `/workspaces/${this.workspaceIdValue}/isolated_edit_address_inline/${addressId}`

    try {
      await get(url, { responseKind: "turbo-stream" })
    } catch (error) {
      console.error("Error fetching edit form:", error)
    }
  }

  cancelEdit(event) {
    if (event) event.preventDefault()

    if (this.hasEditAddressFormTarget) {
      this.editAddressFormTarget.classList.add("d-none")
    }

    if (this.hasAddressSelectTarget) {
      const selectedOption = this.addressSelectTarget.selectedOptions[0]
      if (selectedOption && selectedOption.value !== "new") {
        this.showPreviewForOption(selectedOption)
      }
    }
  }

  setPrimaryOption() {
    if (this.hasAddressSelectTarget && this.hasPrimaryOptionTarget) {
      this.addressSelectTarget.value = this.primaryOptionTarget.value
      this.showPreviewForOption(this.primaryOptionTarget)
    }
  }

  cancelNewAddressForm() {
    this.hideNewAddressForm()
    this.setPrimaryOption()
  }
}
